import React, {useState} from 'react'
import {motion} from 'framer-motion'
import { AppWrap } from '../../wrapper'
import './Programmes.scss'
import { BsChevronCompactLeft, BsChevronCompactRight } from 'react-icons/bs';
import { RxDotFilled } from 'react-icons/rx';
import { images } from '../../constants'
 
const programmes = [
  {title:'Web development',  description: 'I am good', imgurl: images.siunilag},
  {title:'Web Design',  description: 'Whats', imgurl: images.siunilag2},
  {title:'UI/UX',  description: 'good to he', imgurl: images.founilag},
  {title:'Web Aminations',  description: 'I am good', imgurl: images.founilag2},
  {title:'Web Aminations',  description: 'I am good', imgurl: images.founilag2}
]
const Programmes = () => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const prevSlide = () => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? programmes.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  const nextSlide = () => {
    const isLastSlide = currentIndex === programmes.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  const goToSlide = (slideIndex) => {
    setCurrentIndex(slideIndex);
  };

  
  return (
    <>
      <h2 className='head-text'>

      We offer tailored <span> Career-boosting</span> <br /> programmes to <span> Propel your success</span>
      </h2>

      <section className='app__programmes' id='programmes'>

     
          <motion.div

            whileInView={{opacity: 1}}
            whileHover={{scale: 1.1}}
            transition={{duration: 0.5, type: 'tween'}}
            className='app__programmes-item'
            key="1"
          >
             <div className='app__programmes'>
              <div className='app__programmes-bgimg'
              style={{backgroundImage: `url(${programmes[currentIndex].imgurl})`}}
    
              >
                 {/* {programmes.map((slid, index ) => (
                  <p className='prgram-desc p-text'>{slid.description.charAt(currentIndex)}</p>
                 ))} */}
              </div>

              <div className='app__programmes-arrowleft group'>
                <BsChevronCompactLeft onClick={prevSlide} size={30} />
              </div>
              <div className='app__programmes-arrowright group'>
              <BsChevronCompactRight onClick={nextSlide} size={30} />
              
              </div>

              <div className='app__programmes-slide'>
                {
                   programmes.map((slide, slideIndex) => (
                    <div
                      key={slideIndex}
                      onClick={() => goToSlide(slideIndex)}
                      className='app__programmes-slide_slider'
                    >
                    
                      <RxDotFilled  color= {slideIndex === currentIndex ? 'red' : ''}/>
                    </div>
                ))}
               
              </div>
          


             </div>
         
          </motion.div>
 
     

      </section>
    </>
  )
}

export default AppWrap(Programmes, 'programmes')
